import { render } from "./IconDeny.vue?vue&type=template&id=ed0f9f1e"
import script from "./IconDeny.vue?vue&type=script&lang=js"
export * from "./IconDeny.vue?vue&type=script&lang=js"
script.render = render

export default script